// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgBoost: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M17.94 14.446c.714-.661.601-1.594-.25-2.073l-1.608-.904c-.852-.48-1.364-1.637-1.138-2.572L16.88.879c.226-.936-.174-1.16-.888-.5L6.08 9.556c-.714.66-.601 1.593.25 2.073l1.607.903c.852.48 1.365 1.637 1.14 2.572L7.14 23.122c-.226.935.174 1.16.888.498z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgBoost);
export default Memo;
